import React from "react";

const TextFileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="78"
      viewBox="0 0 65 78"
      fill="none"
    >
      <path
        d="M0 3V75C0 76.6569 1.34315 78 3 78H61C62.6569 78 64 76.6569 64 75V20L44 0H3C1.34315 0 0 1.34315 0 3Z"
        fill="white"
      />
      <g filter="url(#filter0_d_809_224)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M44 0L64 20H46.4242C44.9045 20 44 18.9751 44 17.5V0Z"
          fill="#EDEEED"
        />
        <path
          d="M46.4238 19.5H62.793L44.5 1.20703V17.5C44.5 18.136 44.6939 18.6296 45.0059 18.96C45.3143 19.2865 45.7814 19.4999 46.4238 19.5Z"
          stroke="#EDEDED"
        />
      </g>
      <path
        d="M16.6364 36.1307V34.3636H25.9205V36.1307H22.3239V46H20.233V36.1307H16.6364ZM29.4716 34.3636L32.0341 38.625H32.125L34.6989 34.3636H37.1023L33.517 40.1818L37.1591 46H34.7159L32.125 41.767H32.0341L29.4432 46H27.0114L30.6875 40.1818L27.0568 34.3636H29.4716ZM38.2457 36.1307V34.3636H47.5298V36.1307H43.9332V46H41.8423V36.1307H38.2457Z"
        fill="#929292"
      />
      <defs>
        <filter
          id="filter0_d_809_224"
          x="43"
          y="0"
          width="22"
          height="22"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_809_224"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_809_224"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default TextFileIcon;
